// ganttChart
// import criticalPath from "@/views/ScheduleManagGantt/criticalPath.vue";

import index from "@/views/login/index.vue";
import terms from "@/views/login/terms.vue"; //登录协议
import privacy from "@/views/login/privacy.vue"; //用户隐私
//import Login from '@/components/Login.vue'

import gantt from "@/views/ScheduleManagGantt/ganttChart.vue";

export const loginPage = [
  {
    path: "/gantt/",
    name: "Gantt",
    component: gantt,
  },

  {
    path: "/index",
    name: "index",
    component: index,
  },
  {
    path: "/terms",
    name: "terms",
    component: terms,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: privacy,
  },

  {
    path: "/BomComparison",
    component: () => import("@/views/reports/BOMComparison"),
  },
];
